<template lang="pug">
div
  #preloader(v-if="gameLaunching|| favListAction")
    #loader
  template(v-if="!pageLoading")
    .globby.s2
      template(v-if="visibleItems.length > 0")
        template(v-for="game in filteredList()")
          .ggl(v-if="game.GameType == 1")
            a(href="javascript:void(0)" @click='launchEpic(game.GameCode, game.GameName)')
              img.img-fluid(:src='game.ImageUrl')
              span {{game.GameName}} 
    .load(v-if="visibleItems.length < listToDisplay.length" @click="loadMore")
      | Load more 
      span.loaded {{ visibleItems.length }} /
      | {{ listToDisplay.length }}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading: false,
      gameLaunching:false,
      listToDisplay: [],
      temp:[],
      visibleItems: [], // Items currently displayed
      perPage: 15, // Number of items per load
      currentPage: 1,
      favListAction: false,
      offList:[],
      // searchinput: "",
      gameOrder: [
        {id: '45004'},
        {id: '40043'},
        {id: '45001'},
        {id: '45003'},
        {id: '40052'},
        {id: '45002'},
        {id: '45000'},
        {id: '40002'},
        {id: '40039'},
        {id: '40051'},
        {id: '40046'},
        {id: '49999'},
        {id: '40028'},
      ],
      showSearch: false
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
    favList(){
			return this.$store.getters.getFavlist.filter((x)=>x.game_type === "SLOT")
		}
  },
  destroyed(){
    // window.removeEventListener('scroll', this.loadItems)
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
    // var vm = this
    // window.addEventListener('scroll', this.loadItems)
    // $("*").scroll(function(e) {
    //   vm.loadItems()
    // });
  },
  methods:{
    toggleSearch(){
			this.showSearch = !this.showSearch
		},
		cancelSearch(){
			this.showSearch = false
			this.searchinput = ""
		},	
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "epic"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			// var url = config.getEpicGamelist() + `?lang=${this.matchedLocale}` 
      var url = config.getEpic2list() + `?lang=${this.matchedLocale}`
      this.$http.get(url).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {             
              this.gameList = successResponse.data.Game
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.GameCode === obj2.game_id)
              )
              const reOrderList = this.gameOrder.map(x => x.id);
              const customSort = (item1, item2) => {
                const index1 = reOrderList.indexOf(item1.GameCode);
                const index2 = reOrderList.indexOf(item2.GameCode);

                if (index1 === -1 && index2 === -1) {
                  // If neither element is in order_array, maintain the original order.
                  return 0;
                } else if (index1 === -1) {
                  // If only arr1 is not in order_array, move it to the end.
                  return 1;
                } else if (index2 === -1) {
                  // If only arr2 is not in order_array, move it to the end.
                  return -1;
                }

                // Compare the indices in order_array.
                return index1 - index2;
              };
              this.listToDisplay.sort(customSort)
              this.visibleItems= this.listToDisplay.slice(0, this.perPage)
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    loadMore() {
      const start = this.currentPage * this.perPage;
      const newItems = this.listToDisplay.slice(start, start + this.perPage);
      this.visibleItems = [...this.visibleItems, ...newItems];
      this.currentPage++;
    },
    launchEpic(code, name){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = code
        let lang_code = this.matchedLocale
        let game_name = name
        this.$store
          // .dispatch("user/launchEpic", { player_id, auth_token,game_code, lang_code, game_name })
          .dispatch("user/launchEpic2", { player_id, auth_token,game_code, lang_code, game_name })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {     
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				$("#logModal").modal("show")
			}
    },
    filteredList(){
      return this.visibleItems.filter((game) =>
        game.GameName.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
    favAction(provider,game,name,type,img){
      if (this.sessionToken) {
        if(this.favList.some(obj=> obj.game_code === game)){
          this.removeFav(provider, game)
        }else{
          this.addFav(provider,game,name,type,img)
        }
      }else{
        $("#logModal").modal("show")
      }
    },
    addFav(provider,game,name,type,img){
      if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let game_name = name
        let provider_code = provider
        let game_type = type
        let img_url = img
        this.$store
          .dispatch("user/addFav", { account_id, auth_token,game_code, game_name, provider_code, game_type, img_url })
          .then(response => {
            if (response.success == true) {
							// console.log(response)
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    removeFav(provider, game){
			if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              // this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
		},
    checkFav(code){
      if(this.favList.some(obj=> obj.game_code === code)){
        return "fa-solid"
      }else{
        return "fa-regular"
      }
    },
    getFavlist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>